import React, { ReactNode } from 'react';

type ModalDialogAdditionalScrollContainer = {
  children: ReactNode;
};

export default function ModalDialogAdditionalScrollContainer({ children }: ModalDialogAdditionalScrollContainer) {
  return <div className="modal-dialog__additional-scroll-container">{children}</div>;
}
